// extracted by mini-css-extract-plugin
var _1 = "TestHotspotElement_disabled__8aee5";
var _2 = "TestHotspotElement_hidden__db994";
var _3 = "TestHotspotElement_hint__f5250";
var _4 = "TestHotspotElement_image__ddc4d";
var _5 = "TestHotspotElement_preview__cd767";
var _6 = "TestHotspotElement_root__4138d";
var _7 = "TestHotspotElement_v2__a0a1f";
export { _1 as "disabled", _2 as "hidden", _3 as "hint", _4 as "image", _5 as "preview", _6 as "root", _7 as "v2" }
